"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// The enum is defined on the server, and should be kept in sync
// In the server-ows-api project: src/Microsoft.OWS.UserSettings/Models/OutlookOptions/OutlookSettingsFactory.cs
// Work item 11646 in Outlook Web tracks improving this
var OwsOptionsFeatureType;
(function (OwsOptionsFeatureType) {
    OwsOptionsFeatureType[OwsOptionsFeatureType["TestFeature"] = 1] = "TestFeature";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SmartSuggestions"] = 2] = "SmartSuggestions";
    OwsOptionsFeatureType[OwsOptionsFeatureType["DiverseEmojis"] = 4] = "DiverseEmojis";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SurfaceActions"] = 5] = "SurfaceActions";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SkypeNotifications"] = 6] = "SkypeNotifications";
})(OwsOptionsFeatureType = exports.OwsOptionsFeatureType || (exports.OwsOptionsFeatureType = {}));
//# sourceMappingURL=OwsOptionsFeatureType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-outlook-service-options/lib/store/schema/OwsOptionsFeatureType.js
// module id = 2045
// module chunks = 2 3 4 39 49 108